import script from "./SchedaPaziente.vue?vue&type=script&setup=true&lang=ts"
export * from "./SchedaPaziente.vue?vue&type=script&setup=true&lang=ts"

import "./SchedaPaziente.vue?vue&type=style&index=0&id=699fde02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-699fde02"]])

export default __exports__